import component from './FormField.vue'
export default component
